export default __webpack_public_path__ + "images/models/ee90f71ded4e4c6caaf0876b07fdf452.usdz";